import {call} from 'redux-saga/effects';
import {getBanInfo} from './apiGet';
import callApi from '../../common/util/api';
import {toConstantCase} from '../../common/util/string';
import {showBanAlert} from '../common';
import {ICommentLikeStatus, ICommentSort, ReportType} from '../type';

const API_COMMENT = '/comment/v1';

export function callApiGetComments(params: {
  relationId: number;
  relationType: 'CONTENT' | 'EPISODE' | 'EVENT';
  sort: ICommentSort;
  cursor?: string;
  limit: number;
}) {
  return call(callApi, {
    url: `${API_COMMENT}/comments`,
    params: {
      ...params,
      sort: `-${toConstantCase(params.sort)}`,
    },
  });
}

export function callApiGetReplyComments({
  parentId,
  ...params
}: {
  parentId: number;
  cursor?: string;
  limit: number;
}) {
  return call(callApi, {
    url: `${API_COMMENT}/comments/${parentId}/replies`,
    params,
  });
}

export function callApiChangeLikeStatus(
  commentId: number,
  likeStatus: ICommentLikeStatus
) {
  return call(callApi, {
    method: 'POST',
    url: `/comment/v1/comments/${commentId}/review`,
    data: {
      feedback: likeStatus === 'none' ? 'CANCEL' : toConstantCase(likeStatus),
    },
  });
}

export function* callApiPostComment(postData: {
  contentId?: number;
  relationId: number;
  relationType: 'EPISODE' | 'EVENT';
  parentCommentId: number;
  spoiling: boolean;
  text: string;
}) {
  const {success, data} = yield call(callApi, {
    method: 'POST',
    url: `${API_COMMENT}/comments`,
    data: postData,
  });

  if (success && data) {
    const banInfo = getBanInfo(data);
    if (!banInfo) return true;

    showBanAlert(banInfo);
  }
  return false;
}

export function callApiDeleteComment(commentId: number) {
  return call(callApi, {
    method: 'DELETE',
    url: `${API_COMMENT}/comments/${commentId}`,
  });
}

export function callApiReportComment({
  commentId,
  reportType,
  etcText,
}: {
  commentId: number;
  reportType: ReportType;
  etcText?: string;
}) {
  return call(callApi, {
    method: 'POST',
    url: `${API_COMMENT}/comments/${commentId}/report`,
    data: {
      reportType,
      text: etcText,
    },
  });
}

export function callApiBlockUser({
  commentId,
  isBlock,
}: {
  commentId: number;
  isBlock: boolean;
}) {
  return call(callApi, {
    method: isBlock ? 'POST' : 'DELETE',
    url: `${API_COMMENT}/comments/${commentId}/block`,
  });
}
